module.exports = __webpack_public_path__ + "static/media/search-silver.d44d9ccf.svg";